import React from 'react'
import Row from '../../bootstrap/component/Row'
import Column from '../../bootstrap/component/Column'


const ContentBoxWithoutHeader = ({ children }) => {
    return (
        <Row>
            <Column layer="lg" size={12}>
                <div className="content-box">
                    {children}
                </div>
            </Column>
        </Row>
    )
}


ContentBoxWithoutHeader.propTypes = {}

export default ContentBoxWithoutHeader



// WEBPACK FOOTER //
// ./src/modules/layout/component/ContentBoxWithoutHeader.js